var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountrySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.927 17.79L20.4001 21.15M19.2801 12.19C19.2801 16.5199 15.77 20.03 11.4401 20.03C7.11019 20.03 3.6001 16.5199 3.6001 12.19C3.6001 7.86009 7.11019 4.35001 11.4401 4.35001C15.77 4.35001 19.2801 7.86009 19.2801 12.19Z",
    stroke: "#00123A",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountrySearch);
export default __webpack_public_path__ + "static/media/CountrySearch.8d2b8918835521af8f4ef679c951cb7b.svg";
export { ForwardRef as ReactComponent };